<template>
  <div>
    <b-modal ref="modelRef" id="confirm_modal" title="Confirm">
       <b-container fluid>
         <b-row>
           <b-col>Are you sure?</b-col>
         </b-row>
       </b-container>
			<div slot="modal-footer">
				<b-button type="button" variant="primary" @click="onConfirm(item)">Yes</b-button>&nbsp;
				<b-button type="button" variant="secondary" data-dismiss="modal" @click="onCancel">No</b-button>
			</div>
    </b-modal>
  </div>
</template>

<script>
export default {
	props:{
		item:''
	},
	methods:{
		onConfirm(i){
			this.$emit('confirm', i)
			this.$refs.modelRef.hide()
		},
		onCancel(){
			this.$emit('cancel')
			this.$refs.modelRef.hide()
		}
	}
}
</script>